function H3(props) {
    return (
        <h4 className="text-xl font-bold text-darkblue">
            {props.children}
        </h4>
    )
}

export default H3